import React, {useState, Fragment, useEffect, useCallback, useMemo} from "react";
import {connect} from "react-redux"
import {Toaster} from "react-hot-toast";
import FileDropZone from "../utilities/FileDropZone";
import {useForm} from "react-hook-form";
import ProfilAnnexes from "./ProfilAnnexes";


const ProfilForm = (props)=>{

    const [asData, setAsData] = useState(false)
    const [section,setSection] = useState('header')
    const [isLoading, setIsLoading] = useState( false)
    //const [props.entityLocal, props.props.SetEntityLocal] = useState({})
    const [user, setUser] = useState([])
    const [logoFiles, setLogoFiles] = useState([]);
    const [stampFiles, setstampFiles] = useState([]);


    useEffect(()=>{
        //(props.entity)?props.props.SetEntityLocal(props.entity):null;
    }, [])

    useEffect(()=>{
        //(props.entity)?props.props.SetEntityLocal(props.entity):null;
    }, [props.entity])

    useEffect((e)=>{
        //console.log('props.entityLocal', props.entityLocal);
        /*
        (e)?
        props.props.SetEntityLocal({
            ...props.entityLocal,
        })
        :null

         */
    }, [props.entityLocal, props.entityLocal.new_logo, props.entityLocal.new_stamp])

    useEffect(()=>{
        setUser(props.user);
    }, [props.user])

    const getEntity = (evtResult, fileName, ref)=>{

        //console.log('entity_function', props.entityLocal, 'ref : ', ref);
        if(ref==='logo'){
            props.entityLocal.new_logo=evtResult;
            props.entityLocal.new_logo_name=fileName
        }else{
            props.entityLocal.new_stamp=evtResult;
            props.entityLocal.new_stamp_name=fileName;
        }
        //return entity;
        //props.props.SetEntityLocal(props.entityLocal)
    }

    const onUpdateImage=(files, ref)=>{

        let reader = new FileReader()
        reader.readAsDataURL(files[0])
        reader.onloadend = (event)=>{
            let result = event.target.result
            getEntity(result, files[0].name, ref)

            if(ref === "logo") {
                    props.entityLocal.new_logo =  result;
                    props.entityLocal.new_logo_name = files[0].name;
           }else if(ref !== ''){
                props.entityLocal.new_stamp =  result;
                props.entityLocal.new_stamp_name = files[0].name;
            }
                //document.getElementById('submit_profil_form').click();
                /*
                props.updateStructureInfo(prevState => ({
                    ...prevState,
                    ["new_"+ref]: result,
                    ["new_"+ref+"_name"]: files[0].name
                }));

                 */

            }
    }

    return(
        <>
        <ul className="nav nav-pills nav-fill mb-3">
            <li className="nav-item">
                <a className={(section==="header")?"nav-link active":"nav-link"} onClick={(e)=>{setSection('header')}} href="#">Entête/Signature</a>
            </li>
            <li className="nav-item">
                <a className={(section==="annexes")?"nav-link active":"nav-link"} onClick={(e)=>{setSection('annexes')}} href="#">Annexes/mentions</a>
            </li>
        </ul>
            {(section ==="header")?
                <>
                <div className="row">
                    <div className="col-md-5 text-center">
                        {
                            (props.entityLocal && props.entityLocal.new_logo && props.entityLocal.new_logo !== '') ?
                                <>
                                    <div className="card ueThemeBackground ueColorBase p-0 mb-1"
                                         style={{"maxHeight": "300px", "maxWidth": "300px"}}>
                                        <img id={'entity_new_logo'} src={props.entityLocal.new_logo}
                                             alt="new_logo"/>
                                    </div>
                                    <input type={'hidden'} name={'new_logo_src'}
                                           value={props.entityLocal.new_logo}/>
                                    <input type={'hidden'} name={'new_logo_name'}
                                           value={props.entityLocal.new_logo_name}/>
                                    <button className={'btn btn-outline-secondary '}
                                            onClick={() => {
                                                props.entityLocal.new_logo = undefined
                                            }}>
                                        <div className={"bi bi-backspace"}> Annuler</div>
                                    </button>
                                </>
                                : null
                        }
                        {
                            (props.entityLocal && props.entityLocal.logo && props.entityLocal.logo !=='' && !props.entityLocal.new_logo) ?
                                <div className="card card ueThemeBackground ueColorBase  p-0 mb-1"
                                     style={{"maxHeight": "300px", "maxWidth": "300px"}}>
                                    <img id={'entity_logo'}
                                         src={"storage/images/entities/" + props.entityLocal.id + "/" + props.entityLocal.logo}
                                         alt="logo"/>
                                </div>
                                : null
                        }
                        {(props.entityLocal && !props.entityLocal.new_logo) ?
                            <div className="card  ueThemeBackground ueColorBase p-4 mb-1 text-center"
                                 style={{"maxHeight": "300px", "maxWidth": "300px"}}>
                                <FileDropZone name={'logo'}
                                              title={'<span class="text-primary">LOGO</span> <br/> cliquez ou déposez un fichier <br/>(jpg, png)'}
                                              onUpdateFile={onUpdateImage}/>
                            </div>
                            : null
                        }
                    </div>
                    <div className="col-md-7">
                        <div className="form-group row">
                            <div className="col-sm-12">
                                <input type="text" className="form-control" id="header_name"
                                       name="header_name"
                                       ref={props.refRegister}
                                       placeholder={"Nom structure"}
                                       defaultValue={(props.entityLocal?.header_form_ref?.header_name) ? props.entityLocal.header_form_ref.header_name : null}/>
                            </div>
                        </div>
                        <div className="form-group row ">
                            <div className="col-sm-12">
                                <input type="text" className="form-control" id="header_address"
                                       name="header_address"
                                       ref={props.refRegister}
                                       placeholder={"Adresse"}
                                       defaultValue={(props.entityLocal?.header_form_ref?.header_address) ? props.entityLocal.header_form_ref.header_address : null}/>
                            </div>
                        </div>
                        <div className="form-group row ">
                            <div className="col-sm-6">
                                <input type="text" className="form-control" id="header_city"
                                       name="header_city"
                                       ref={props.refRegister}
                                       placeholder={"Ville"}
                                       defaultValue={(props.entityLocal?.header_form_ref?.header_city) ? props.entityLocal.header_form_ref.header_city : null}/>
                            </div>
                            <div className="col-sm-6">
                                <input type="text" className="form-control" id="header_cp"
                                       name="header_cp"
                                       ref={props.refRegister}
                                       placeholder={"CP"}
                                       defaultValue={(props.entityLocal?.header_form_ref?.headercp) ? props.entityLocal.header_form_ref.headercp : null}/>
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-sm-12">
                                <input type="text" className="form-control" id="header_code"
                                       name="header_code"
                                       readOnly
                                       ref={props.refRegister}
                                       defaultValue={(props.entityLocal.siren) ? props.entityLocal.siren : ''}/>
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-sm-6">
                                <input type="text" className="form-control" id="header_email"
                                       name="header_email"
                                       ref={props.refRegister({pattern: /^\S+@\S+\.\S+$/i})}
                                       placeholder={"email"}
                                       defaultValue={(props.entityLocal?.header_form_ref?.header_email) ? props.entityLocal.header_form_ref.header_email : null}/>
                                {props.errors.email && <span className={'text-danger mt-1'}>Cet email est requis !</span>}
                            </div>
                            <div className="col-sm-6">
                                <input type="text" className="form-control" id="header_phone"
                                       name="header_phone"
                                       ref={props.refRegister}
                                       placeholder={"tél."}
                                       defaultValue={(props.entityLocal?.header_form_ref?.header_phone) ? props.entityLocal.header_form_ref.header_phone : null}/>
                            </div>
                        </div>
                    </div>
                <h6 className={"font-weight-bold mt-md-3"}>Signature</h6>
                <hr/>
                </div>
                <div className="row ">
                    <div className="col-md-5 text-center">
                        {
                            (props.entityLocal && props.entityLocal.new_stamp && props.entityLocal.new_stamp !== '') ?
                                <>
                                    <div className="card ueThemeBackground ueColorBase p-0 mb-1"
                                         style={{"maxHeight": "300px", "maxWidth": "300px"}}>
                                        <img id={'entity_new_stamp'} src={props.entityLocal.new_stamp}
                                             alt="new_stamp"/>
                                    </div>
                                    <input type={'hidden'} name={'new_stamp_src'}
                                           value={props.entityLocal.new_stamp}/>
                                    <input type={'hidden'} name={'new_stamp_name'}
                                           value={props.entityLocal.new_stamp_name}/>
                                    <button className={'btn btn-outline-secondary '}
                                            onClick={() => {
                                                props.entityLocal.new_stamp=undefined
                                            }}>
                                        <i className="bi bi-backspace"/> Annuler
                                    </button>
                                </>
                                : null
                        }
                        {
                            (props.entityLocal && props.entityLocal.stamp && props.entityLocal.stamp !== '' && !props.entityLocal.new_stamp) ?
                                <div className="card ueThemeBackground ueColorBase p-0 mb-1"
                                     style={{"maxHeight": "300px", "maxWidth": "300px"}}>
                                    <img id={'entity_stamp'}
                                         src={"storage/images/entities/" + props.entityLocal.id + "/" + props.entityLocal.stamp}
                                         alt="stamp"/>
                                </div>
                                : null
                        }
                        {(props.entityLocal && !props.entityLocal.new_stamp) ?
                            <div className="card  ueThemeBackground ueColorBase p-4 mb-1 text-center"
                                 style={{"maxHeight": "300px", "maxWidth": "300px"}}>
                                <FileDropZone name={'stamp'}
                                              title={'<span class="text-primary">TAMPON</span> <br/> cliquez ou déposez un fichier </br>(jpg, png)'}
                                              onUpdateFile={onUpdateImage}/>
                            </div>
                            : null
                        }
                    </div>
                    <div className="col-md-7">
                        <div className="form-group">
                            <label htmlFor="sign_text">Référence signature</label>
                            <textarea className="form-control" id="sign_text" name="sign_text"
                                      rows="10" ref={props.refRegister}
                                      defaultValue={(props.entityLocal?.header_form_ref?.sign_text) ? props.entityLocal.header_form_ref.sign_text : null}>
                            </textarea>
                        </div>
                    </div>
                </div>
                </>
            :<ProfilAnnexes annexes={props.annexes} register={props.refRegister} reset={props.reset}/>
            }
        </>
    )
}


const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        entity: state.MeReducer.entity,
        username : state.MeReducer.username,
        role : state.MeReducer.role,
        types: state.SubscribtionReducer.types,
        structureInfo: state.SubscribtionReducer.structureInfo,
    }
}


const mapDispatchTProps = dispatch => {
    return {
        updateStructureInfo: (e) => dispatch( {type: 'UPDATE_STRUCTURE_INFO', data:e}),
        updateUserInfo: (e) => dispatch( {type: 'UPDATE_USER_STATUS', data:e}),
    }
}


export default connect(mapStateToProps, mapDispatchTProps)(ProfilForm);

